import React from 'react';
import {FormGroup, ControlLabel, FormControl} from 'react-bootstrap';
import ReactSelect from 'react-select';
import {isEmpty} from 'lodash/lang';

export class Select extends React.Component {
  static defaultProps = {
    labelKey: 'label',
    valueKey: 'value',
    required: false,
    creatable: false,
    multi: false,
    openOnFocus: true,
    searchPromptText: false,
    loadingPlaceholder: false,
    noResultsText: false,
    removeSelected: true,
  };

  componentDidMount() {
    const {defaultValue, input} = this.props;
    if (isEmpty(input.value) && !isEmpty(defaultValue)) {
      input.onChange(defaultValue);
    }
  }

  render() {
    const {
      input,
      label,
      required,
      placeholder,
      options,
      helpText,
      meta: {error, warning, touched},
      multi,
      ...props
    } = this.props;

    let errorMessage;
    const validationState = (touched && error && 'error') || (warning && 'warning') || null;

    if (touched && (error || warning)) {
      errorMessage = <span className="help-block">{error || warning}</span>;
    }

    let placeholderText = 'Type to search';
    if (placeholder !== undefined) {
      placeholderText = placeholder;
    }

    const asterisk = (required && <span className="form-field-required" />) || null;

    return (
      <FormGroup validationState={validationState}>
        <ControlLabel>
          {label}
          {asterisk}
        </ControlLabel>
        <ReactSelect
          {...{
            ...input,
            value: input.value,
            onBlur: () => input.onBlur(input.value),
            options,
            placeholder: placeholderText,
            multi,
            autoBlur: !multi,
            closeOnSelect: !multi,
            ...props,
          }}
        />
        {helpText && <span className="help-text">{helpText}</span>}
        {errorMessage}
        <FormControl.Feedback />
      </FormGroup>
    );
  }
}
